import { Box, Grid, Typography } from '@mui/material';

import { FormNumberField, FormTextField } from '../../../../../common';
import {
  MEDICAL_FIELD_GROUP_SX,
  MEDICAL_INLINE_NUMBER_SX,
  MEDICAL_INLINE_TEXT_SX,
  MEDICAL_NUMERIC_GROUP_SX,
} from './styles';

import type { MedicalFieldsProps } from '../types';

export default function ChildDevelopmentFields({
  formik,
  disabled,
  readOnly,
  saveField,
}: MedicalFieldsProps) {
  return (
    <Grid container spacing={1}>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 160px', fontSize: 14 }}>Child began sitting independently at</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Months"
              max={99}
              min={0}
              name="child_sitting_up_age_months"
              onBlur={saveField}
              placeholder="months"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 160px', fontSize: 14 }}>Child began crawling at</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Months"
              max={99}
              min={0}
              name="child_crawling_age_months"
              onBlur={saveField}
              placeholder="months"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 130px', fontSize: 14 }}>Child began walking at</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Years"
              max={99}
              min={0}
              name="child_walking_age_years"
              onBlur={saveField}
              placeholder="years"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Months"
              max={99}
              min={0}
              name="child_walking_age_months"
              onBlur={saveField}
              placeholder="months"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 155px', fontSize: 14 }}>Child began standing independently at</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Years"
              max={9}
              min={0}
              name="child_standing_age_years"
              onBlur={saveField}
              placeholder="years"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Months"
              max={99}
              min={0}
              name="child_standing_age_months"
              onBlur={saveField}
              placeholder="months"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 160px', fontSize: 14 }}>Child began babbling at</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Months"
              max={99}
              min={0}
              name="child_babbling_age_months"
              onBlur={saveField}
              placeholder="months"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12} md={6}>
        <Box sx={MEDICAL_FIELD_GROUP_SX}>
          <Box sx={MEDICAL_NUMERIC_GROUP_SX}>
            <Typography sx={{ flex: '1 1 145px', fontSize: 14 }}>Child first word(s) was/were</Typography>
            <FormTextField
              disabled={disabled}
              formik={formik}
              label="Word"
              name="child_first_word"
              onBlur={saveField}
              placeholder="word"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_TEXT_SX}
            />
            <FormTextField
              disabled={disabled}
              formik={formik}
              label="Word"
              name="child_second_word"
              onBlur={saveField}
              placeholder="word"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_TEXT_SX}
            />
            <Typography sx={{ fontSize: 14 }}>at</Typography>
            <FormNumberField
              disabled={disabled}
              formik={formik}
              label="Months"
              max={99}
              min={0}
              name="child_first_words_age_months"
              onBlur={saveField}
              placeholder="months"
              readOnly={readOnly}
              required
              sx={MEDICAL_INLINE_NUMBER_SX}
            />
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
